import { api } from "../helpers/apiHelper";
const API_SELF_EXCLUSION = "/account/self-exclusion";
/**
 * apply self exclusion time period to user
 */
export const setSelfExclusionPeriod = (exclusionEndDateMillis: number) => {
  const url = API_SELF_EXCLUSION;
  const data = {
    exclusionEndDateMillis: exclusionEndDateMillis,
  };

  return api.post(url, data);
};
